export default "__VITE_ASSET__870b31d5__"